/** Opportunity capture rate: share of detected opportunities acted upon. */
import type { CaptureRatePayload } from "@/types/feed";

import { customerBookingsHref } from "../../feedLinks";
import { explainerFor, periodLabel } from "../insightCopy";
import {
  ChangeRow,
  EntitySection,
  InsightShell,
  MetricGrid,
  PeriodBanner,
  type MetricItem,
} from "../primitives";

export function CaptureRateView({ payload }: { payload: CaptureRatePayload }) {
  const m = payload.metrics;
  const period = periodLabel(payload as unknown as Record<string, unknown>);
  const metricItems: MetricItem[] = m
    ? [
        { label: "Capture rate", value: `${Math.round(m.capture_rate_pct)}%` },
        { label: "Detected", value: String(m.detected) },
        { label: "Actionable", value: String(m.actionable) },
        { label: "Acted upon", value: String(m.acted_upon) },
      ]
    : [];

  return (
    <InsightShell explainer={explainerFor(payload as unknown as Record<string, unknown>)}>
      {period && <PeriodBanner label={period} />}
      {metricItems.length > 0 && <MetricGrid items={metricItems} />}
      {payload.top_laggards && payload.top_laggards.length > 0 && (
        <EntitySection title="Lagging customers">
          {payload.top_laggards.map((l) => (
            <ChangeRow
              key={l.consignee}
              name={l.consignee}
              href={customerBookingsHref(l.consignee)}
              party
              primary={`${l.acted}/${l.detected} acted`}
              bar={{ type: "ratio", value: l.acted, total: l.detected }}
            />
          ))}
        </EntitySection>
      )}
    </InsightShell>
  );
}
